module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "uk-team-reports-upsell-illustration.16173ffb.png" + "?" + Date.now();